export enum ProductApi {
  getProduct = '/product/:productId',
  getProductLastSoldDetails = '/order-items/history',
  realtimeInventory = '/inventory/realtime/:productId'
}
